// ponytail: drop-in Grid that hoists legacy v4/v5 layout props (justifyContent,
// alignItems, direction alignment aliases) into sx so React 19 stops warning
// about unknown DOM attrs. v9 Grid keeps `container`, `item`, `size`, `spacing`,
// `wrap`, `direction`, `columns` — everything else moves to sx.
import React from "react";
import MuiGrid from "@mui/material/Grid";

const LAYOUT = new Set([
  "justifyContent", "alignItems", "alignContent", "alignSelf",
  "justifyItems", "justifySelf",
  "flexWrap", "flexDirection", "flexGrow", "flexShrink", "flex",
  "gap", "rowGap", "columnGap",
  "m", "mt", "mb", "ml", "mr", "mx", "my",
  "margin", "marginTop", "marginBottom", "marginLeft", "marginRight",
  "p", "pt", "pb", "pl", "pr", "px", "py",
  "padding", "paddingTop", "paddingBottom", "paddingLeft", "paddingRight",
  "width", "height", "minWidth", "minHeight", "maxWidth", "maxHeight",
  "textAlign", "position", "top", "left", "right", "bottom", "zIndex",
  "overflow", "overflowX", "overflowY", "order", "display",
  "bgcolor", "color", "borderRadius", "border", "boxShadow",
]);

const BREAKPOINTS = ["xs", "sm", "md", "lg", "xl"];

export default function Grid({ sx, size, ...props }) {
  const extracted = {};
  const rest = {};
  const bpSize = {};
  for (const key of Object.keys(props)) {
    if (LAYOUT.has(key)) extracted[key] = props[key];
    else if (BREAKPOINTS.includes(key)) bpSize[key] = props[key];
    else rest[key] = props[key];
  }
  // v9 Grid uses `size={{xs:12, md:6, ...}}`; keep provided `size` if any, otherwise
  // fold legacy xs/sm/md/lg/xl into it.
  const mergedSize =
    Object.keys(bpSize).length === 0 ? size : { ...bpSize, ...(size || {}) };
  const mergedSx =
    Object.keys(extracted).length === 0
      ? sx
      : sx
        ? { ...extracted, ...(typeof sx === "object" && !Array.isArray(sx) ? sx : {}) }
        : extracted;
  const finalProps = { ...rest };
  if (mergedSize !== undefined) finalProps.size = mergedSize;
  return <MuiGrid sx={mergedSx} {...finalProps} />;
}
